module.exports = __webpack_public_path__ + "static/media/creator2.66ce390c.png";